import sea from './imgs/sea.png';

const data = {
  id: 1,
  title: 'Look and write',
  subTitle: 'Nhìn hình và hoàn thành từ với chữ cái cho sẵn',
  question: 's__',
  answers: 'sea',
  audioUrl: '',
  imageUrl: 'https://cloud.softech.vn/storage/SachSo/Images/Vocabulary/Starters/sea.png',
};

export default data;
